const LOCAL_AGENT_META_TYPE = 'breeze-custom-agent';
const LOCAL_MANAGED_WORKER_META_TYPE = 'breeze-managed-worker-local';
const BENDER_PROXY_CONFIG_PATH = '/bender-proxy/config';
const QA_TLDS = ['hubspotqa.com', 'hubteamqa.com'];
export function getBenderProxyOrigin(hostname = window.location.hostname) {
  for (const tld of QA_TLDS) {
    if (hostname === `local.${tld}`) {
      break;
    }
    if (hostname.endsWith(`.${tld}`)) {
      return `https://local.${tld}`;
    }
  }
  return '';
}
export function buildBenderProxyUrl(path) {
  return `${getBenderProxyOrigin()}${path}`;
}
export async function fetchLocalDevStatus() {
  try {
    const response = await fetch(buildBenderProxyUrl(BENDER_PROXY_CONFIG_PATH), {
      credentials: 'include'
    });
    if (!response.ok) {
      return {
        localAgentRoutes: [],
        managedWorkerRunningLocally: false
      };
    }
    const data = await response.json();
    const localAgents = new Map();
    let managedWorkerRunningLocally = false;
    for (const {
      config
    } of (_data$applied = data.applied) !== null && _data$applied !== void 0 ? _data$applied : []) {
      var _data$applied;
      const meta = config === null || config === void 0 ? void 0 : config.meta;
      if ((meta === null || meta === void 0 ? void 0 : meta.type) === LOCAL_AGENT_META_TYPE && meta.agentId && !localAgents.has(meta.agentId)) {
        localAgents.set(meta.agentId, {
          agentId: meta.agentId,
          agentName: meta.agentName || meta.agentId
        });
      }
      if ((meta === null || meta === void 0 ? void 0 : meta.type) === LOCAL_MANAGED_WORKER_META_TYPE) {
        managedWorkerRunningLocally = true;
      }
    }
    return {
      localAgentRoutes: Array.from(localAgents.values()),
      managedWorkerRunningLocally
    };
  } catch (_unused) {
    return {
      localAgentRoutes: [],
      managedWorkerRunningLocally: false
    };
  }
}
export async function fetchLocalAgentRoutes() {
  const status = await fetchLocalDevStatus();
  return status.localAgentRoutes;
}